import * as v from 'valibot';
import { zigbeeGUILevelSchema } from '../types/ZigbeeGUILevel';
import { zigbeeGUITemperatureSchema } from '../types/ZigbeeGUITemperature';
export const zigbeeGUISchema = v.object({
    level: v.optional(zigbeeGUILevelSchema),
    temperature: v.optional(zigbeeGUITemperatureSchema),
});
